import React from 'react';
import { Link } from 'react-router-dom';
import { menuAPI } from '../../InterfaceAPI/menuAPI';
import SortableList from '../shared/SortableList';
import ListItem from '../shared/ListItem';
import Pagination from '../shared/Pagination';
import SearchInput from '../form/SearchInput';
import { maskMoney } from '../../masks';
import { debounce } from '../../helpers/util';
import withTracker from '../withTracker';

class AdminProducts extends React.Component {
  state = {
    isOpen: false,
    searchTerm: '',
    sortBy: [],
    products: [],
    pagination: {},
    isLoading: true
  };

  // options
  // label: Shows in TH
  // headClass: css class applied to `th`
  // class: css class applied to `td`
  // link: to: url string, label: the link's content
  // mask: a function to run on the contents of the `td`
  // dive: specify a child object's property
  columns = [
    {
      label: 'Name',
      key: 'name',
      headClass: 'products__td--name',
      class: 'products__td--name',
      link: { to: '/admin/product/[id]', advancedLabel: { key: 'name' } }
    },
    {
      label: 'Unit Price',
      key: 'unit_price_cents',
      mask: maskMoney,
      headClass: 'products__td--price',
      class: 'products__td--price table__td--right'
    },
    {
      label: 'Unit',
      key: 'product_unit',
      sortable: false,
      dive: 'name',
      headClass: 'products__td--unit',
      class: 'products__td--unit'
    },
    {
      label: 'Purchase Price',
      key: 'paid_price_cents',
      mask: maskMoney,
      headClass: 'products__td--price',
      class: 'products__td--price table__td--right'
    },
    {
      label: 'Purchase Unit',
      key: 'product_format',
      sortable: false,
      dive: 'name',
      headClass: 'products__td--punit',
      class: 'products__td--punit'
    },
    {
      label: 'Category',
      key: 'product_category',
      dive: 'name',
      headClass: 'products__td--long',
      class: 'products__td--long'
    },
    {
      label: 'Vendor',
      key: 'product_vendor',
      dive: 'name',
      headClass: 'products__td--long',
      class: 'products__td--long'
    },
    {
      label: '',
      sortable: false,
      link: { to: '/admin/product/[id]', label: 'Edit' },
      headClass: 'products__td--edit',
      class: 'products__td--edit'
    }
  ];

  render() {
    const { columns, handleChange, handleSort, handlePaginate } = this;
    const { searchTerm, products, sortBy, pagination, isLoading } = this.state;
    return (
      <div className="products cms">
        <div className="cms__head cms__head--padding">
          <div className="cms__content">
            <div className="cms__bar">
              <div className="cms__bar-left">
                <h1 className="h2">Product Library</h1>
                <p className="p p--dark-taupe">
                  {pagination.total_items || 0} Total
                </p>
              </div>
              <div className="cms__bar-right">
                <Link to="/admin/product" className="btn btn--solid-blue">
                  Add a New Product
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="cms__body">
          <div className="cms__content">
            <SearchInput
              placeholder="Search Products"
              value={searchTerm}
              onChange={handleChange}
            />
            <div className="cms__list-wrap">
              <SortableList
                columns={columns}
                rows={products}
                sort={sortBy}
                ListItem={ListItem}
                handleSort={handleSort}
                isLoading={isLoading}
              />
            </div>
            <div className="cms__pagination">
              <Pagination
                pageCount={pagination.total_pages || 1}
                forcePage={pagination.current_page - 1 || 0}
                onPageChange={handlePaginate}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  handleSort = prop => {
    const column = this.columns.find(c => c.key === prop);
    const isSortable = !column.sortable || column.sortable !== false;
    // don't do anything is the property is marked as `sortable: false`
    if (!isSortable) return;

    let { sortBy } = this.state;

    const index = sortBy.findIndex(option => prop in option);
    if (index >= 0 && sortBy[index][prop] === 'asc') {
      sortBy[index][prop] = 'desc';
    } else if (index >= 0 && sortBy[index][prop] === 'desc') {
      sortBy = [
        ...sortBy.slice(0, index),
        ...sortBy.slice(index + 1, sortBy.length)
      ];
    } else {
      sortBy.push({ [prop]: 'asc' });
    }
    this.setState({ sortBy }, this.debouncedLoadProducts);
  };

  handleChange = e => {
    const value =
      e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    const name = e.target.name;

    console.log({ name, value });

    this.setState({ [name]: value }, this.debouncedLoadProducts);
  };

  handlePaginate = ({ selected: page }) => {
    this.loadProducts(page + 1);
  };

  loadProducts = (page = 1) => {
    const { searchTerm: name, sortBy: sort } = this.state;
    // clear existing
    this.setState({ products: [], isLoading: true });

    // make request
    menuAPI
      .searchProducts({ page, sort, search: { name } })
      .then(({ products, pagination }) =>
        this.setState({ products, pagination, isLoading: false })
      )
      .catch(error => console.log(error));
  };

  // react's correct implementation of debounce
  debouncedLoadProducts = debounce(() => this.loadProducts(), 250);

  componentDidMount() {
    this.loadProducts();
  }
}

export default withTracker(AdminProducts);



// WEBPACK FOOTER //
// ./src/components/admin/AdminProducts.js